module.exports = __webpack_public_path__ + "static/media/md-cloud-upload.0c074248.svg";